import { useFinancialContext } from '../context/FinancialContext';

export const useFinancialData = () => {
    return useFinancialContext();
};
